<template>
  <div
    class="h-9 w-auto rounded-full bg-orange-100 py-1.5 px-3 font-medium text-orange-500"
  >
    <slot />
  </div>
</template>
